<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div v-if="isEmpty" class="body-editorial-block">
      <div class="editorial-content">
          <div class="text-wrapper">
            <ScRichText tag="div" class="paragraph rich-text-block" :field="fields.paragraph"/>
          </div>
          <image-block :fields="fields"/>
          <div :class="getClass">
            <ScRichText tag="blockquote" class="quote" :field="fields.quote"/>
          </div>
      </div>
    </div>
  </sc-render>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue'
import isEmptyObject from '~/helpers/is-empty-object'
import ImageBlock from '../image-block'
import ScRender from '../sc-render'

export default {
  name: 'BodyEditorialBlock',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScRichText: RichText,
    ImageBlock,
    ScRender
  },
  computed: {
    getClass () {
      return this.fields.quote && this.fields.quote.value ? 'quote-wrapper' : 'no-quotes'
    },
    isEmpty () {
      return this.rendering.dataSource && !isEmptyObject(this.fields)
    }
  }
}
</script>

<style lang="scss" scoped>
.body-editorial-block {
  position: relative;
}

  .editorial-content {
    max-width: 44em;
    position: relative;
    margin: 0 $space-060;

    @include tablet {
      width: 80%;
      margin: 0 auto;
    }
  }

  .paragraph {
    @include font('070');

    margin: $space-080 0;

    ::v-deep h1,
    ::v-deep h2,
    ::v-deep h3,
    ::v-deep h4,
    ::v-deep h5,
    ::v-deep h6{
      margin-bottom: $space-060;
    }

    ::v-deep p {
      margin-bottom: $space-070;
    }

    ::v-deep br {
      margin-bottom: $space-050;
    }

    @include tablet {
      margin: $space-060 0 $space-090;
    }
  }

  .text-wrapper {
    position: relative;

    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }

  .quote-wrapper {
    position: relative;
    border-top: 3px solid $color-black;

    @include tablet {
      margin-top: $space-060;
    }

    .quote {
      @include font('070');
      font-style: italic;
      font-stretch: normal;
      letter-spacing: normal;
      color: $color-black;
      margin: $space-070 0;

      @include tablet {
        margin: $space-050 0 $space-090;
      }
    }
  }

  .no-quote {
    position: relative;
    margin-top: $space-060;

    @include tablet {
      border-top: 0 solid $color-black;
    }
}
</style>
